import { Borrower } from "@data/schema/loan-appication/borrower";
import { LoanInfo } from "@data/schema/loan-appication/loan-info";
import { InterviewerDetails } from "@data/schema/loan-appication/interviewer-details";
import { Assignment } from "@data/schema/loan-appication/assignment";
import { GeneralDates } from "@data/schema/loan-appication/general-dates";

export class LoanApplication {
  borrower: Borrower[] = [];
  id: string;
  sLoanInfo: LoanInfo = new LoanInfo();
  sInterviewerDetails: InterviewerDetails = new InterviewerDetails();
  sAssignments: Assignment = new Assignment();
  sDates: GeneralDates = new GeneralDates();
}
